import React from 'react';
import { useHistory } from 'react-router-dom';
import {updateHistory, checkForFilters} from '../utils/data';
import {useFilterContext, useFilterDispatch, emptyFilters, adminFilterOps} from '../contexts/FilterContextProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const Selection = ({selection, deselect}) => {
    return (
        <div className="filter-selection" onClick={() => deselect(selection)}>
            <button className="btn btn-sm"><FontAwesomeIcon icon={faTimes} /></button> {selection.param === "clearAll" ? <strong>{selection.display}</strong> : selection.display}
        </div>
    );
}

function FilterSelections() {
    const filters = useFilterContext();
    const filterDispatch = useFilterDispatch();
    const history = useHistory();
    var selections = [];

    if (filters.search.length) {
        selections.push({
            display: "Search: " + filters.search,
            value: filters.search,
            param: "search"
        });
    }
    for (var property in filters.location) {
        if (filters.location[property].selectedLocation.length) {
            selections.push({
                display: filters.location[property].displayName + ": " + filters.location[property].selectedLocation,
                value: filters.location[property].selectedLocation,
                param: filters.location[property].name
            });
        }
    }
    if (filters.phase.length) {
        for (let i = 0; i < filters.phase.length; i++) {
            if (filters.phase[i].length) {
                selections.push({
                    display: "Phase: " + filters.phase[i],
                    value: filters.phase[i],
                    param: "phase"
                });
            }
        }
    }
    if (filters.performance.length) {
        for (let i = 0; i < filters.performance.length; i++) {
            if (filters.performance[i].length) {
                selections.push({
                    display: "Performance: " + filters.performance[i],
                    value: filters.performance[i],
                    param: "performance"
                });
            }
        }
    }
    if (filters.year.length) {
        for (let i = 0; i < filters.year.length; i++) {
            if (filters.year[i].length) {
                selections.push({
                    display: "Year: " + filters.year[i],
                    value: filters.year[i],
                    param: "year"
                });
            }
        }
    }
    if (filters.type.length) {
        for (let i = 0; i < filters.type.length; i++) {
            if (filters.type[i].length) {
                selections.push({
                    display: "Type: " + filters.type[i],
                    value: filters.type[i],
                    param: "type"
                });
            }
        }
    }
    if (filters.admin.length) {
        for (let i = 0; i < filters.admin.length; i++) {
            if (filters.admin[i].length) {
                let adminDisplay = "";
                for (let j = 0; j < adminFilterOps.length; j++) {
                    if (adminFilterOps[j].val === filters.admin[i]) {
                        adminDisplay = adminFilterOps[j].display;
                    }
                }
                selections.push({
                    display: "Administrator: " + adminDisplay !== "" ? adminDisplay : filters.admin[i],
                    value: filters.admin[i],
                    param: "admin"
                });
            }
        }
    }
    if (filters.mapPoint.length) {
        selections.push({
            display: "Map Selection",
            value: "",
            param: "mapSelection"
        });
    }
    if (filters.mapped.length) {
        for (let i = 0; i < filters.mapped.length; i++) {
            if (filters.mapped[i].length) {
                selections.push({
                    display: (filters.mapped[i] === 'TRUE' ? "Mapped" : "Non-mapped") + " Projects",
                    value: filters.mapped[i],
                    param: "mapped"
                });
            }
        }
    }

    if (selections.length) {
        selections.unshift({
            display: "Clear all",
            value: "clearAll",
            param: "clearAll"
        });
    }

    const deselect = (selection) => {
        let newFilters = JSON.parse(JSON.stringify(filters));

        switch(selection.param) {
            case "search":
                newFilters.search = "";
                newFilters.page = checkForFilters(newFilters) ? "" : "projects";
                filterDispatch({
                    type: 'search',
                    payload: "",
                    pagePayload: newFilters.page
                });
                updateHistory(history, newFilters);
                break;
            case "phase":
                newFilters.phase.length && newFilters.phase.splice(newFilters.phase.indexOf(selection.value), 1);
                newFilters.page = checkForFilters(newFilters) ? "" : "projects";
                filterDispatch({
                    type: 'phase',
                    payload: selection.value,
                    pagePayload: newFilters.page
                });
                updateHistory(history, newFilters);
                break;
            case "performance":
                newFilters.performance.length && newFilters.performance.splice(newFilters.performance.indexOf(selection.value), 1);
                newFilters.page = checkForFilters(newFilters) ? "" : "projects";
                filterDispatch({
                    type: 'performance',
                    payload: selection.value,
                    pagePayload: newFilters.page
                });
                updateHistory(history, newFilters);
                break;
            case "year":
                newFilters.year.length && newFilters.year.splice(newFilters.year.indexOf(selection.value), 1);
                newFilters.page = checkForFilters(newFilters) ? "" : "projects";
                filterDispatch({
                    type: 'year',
                    payload: selection.value,
                    pagePayload: newFilters.page
                });
                updateHistory(history, newFilters);
                break;
            case "type":
                newFilters.type.length && newFilters.type.splice(newFilters.type.indexOf(selection.value), 1);
                newFilters.page = checkForFilters(newFilters) ? "" : "projects";
                filterDispatch({
                    type: 'type',
                    payload: selection.value,
                    pagePayload: newFilters.page
                });
                updateHistory(history, newFilters);
                break;
            case "admin":
                newFilters.admin.length && newFilters.admin.splice(newFilters.admin.indexOf(selection.value), 1);
                newFilters.page = checkForFilters(newFilters) ? "" : "projects";
                filterDispatch({
                    type: 'admin',
                    payload: selection.value,
                    pagePayload: newFilters.page
                });
                updateHistory(history, newFilters);
                break;
            case "mapSelection":
                newFilters.mapPoint = "";
                newFilters.page = checkForFilters(newFilters) ? "" : "projects";
                filterDispatch({
                    type: 'mapPoint',
                    payload: "",
                    pagePayload: newFilters.page,
                    updatedFilterPayload: "removedMapPoint",
                    selectedForSnapshotPayload: filters.selectedForSnapshot !== "" ? filters.selectedForSnapshot : "",
                    extentPayload: filters.extent ? filters.extent : null
                });
                updateHistory(history, newFilters);
                break;
            case "mapped":
                newFilters.mapped.length && newFilters.mapped.splice(newFilters.mapped.indexOf(selection.value), 1);
                newFilters.page = checkForFilters(newFilters) ? "" : "projects";
                filterDispatch({
                    type: 'mapped',
                    payload: selection.value,
                    pagePayload: newFilters.page
                });
                updateHistory(history, newFilters);
                break;
            case "clearAll":
                newFilters = JSON.parse(JSON.stringify(emptyFilters));
                newFilters.map = filters.map.includes("show") ? newFilters.map.concat(["show"]) : [];
                newFilters.page = "projects"
                filterDispatch({
                    type: 'clearFilters',
                    payload: ""
                });
                updateHistory(history, newFilters);
                break;
            default: 
                newFilters.location[selection.param].selectedLocation = "";
                newFilters.page = checkForFilters(newFilters) ? "" : "projects";
                filterDispatch({
                    type: 'location',
                    subtype: selection.param,
                    payload: "",
                    pagePayload: newFilters.page
                });
                updateHistory(history, newFilters);
                break;
        }        
    };

    return (
        <>
            {selections.length > 0 &&
                <div style={filters.map === null ? {marginBottom: "20px"} : {}}>
                    
                    {selections.map(selection => {
                        return(
                            <Selection key={selection.display} selection={selection} deselect={deselect}/>
                        );
                    })}
                </div>
            }
        </>
    );
}

export default FilterSelections;